$(function() {

	const hasReCaptcha = $("#recaptcha-key").length;

	// reCaptcha
	$("#logon-form").on("submit", event => {
		const tokenInput = $("#recaptcha-token");

		if(tokenInput.val() === "" && hasReCaptcha) {
			event.preventDefault();
			grecaptcha.ready(function() {
				grecaptcha.execute($("#recaptcha-key").val(), {action: 'login'}).then(function(token) {
					tokenInput.val(token);
					$("#logon-form-submit").click();
				});
			});
		}
	});
});
